import ScoreRPE from './ScoreRPE';

export default ScoreRPE;